/** Inline error banner with optional retry. Previously duplicated in ~12 files. */
import React from "react";

interface ErrorBannerProps {
  message: string;
  onRetry?: () => void;
  /** Softer presentation for partial/non-blocking failures. */
  tone?: "danger" | "warning";
  className?: string;
}

export default function ErrorBanner({
  message,
  onRetry,
  tone = "danger",
  className = "",
}: ErrorBannerProps) {
  const toneClasses =
    tone === "warning"
      ? "bg-warning-subtle border-warning-border text-warning-fg"
      : "bg-danger-subtle border-danger-border text-danger-fg";

  return (
    <div
      role="alert"
      className={`flex items-start justify-between gap-4 rounded-lg border px-4 py-3 text-sm ${toneClasses} ${className}`}
    >
      <span className="min-w-0 break-words">{message}</span>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 font-medium underline underline-offset-2 hover:no-underline"
        >
          Retry
        </button>
      ) : null}
    </div>
  );
}
